var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "openingReport" },
    [
      _c("div", { staticClass: "cont-box" }, [
        _c(
          "div",
          { staticClass: "classTitle" },
          [_c("Title", { attrs: { text: "开题报告", isShowBack: true } })],
          1
        ),
        _c(
          "div",
          [
            _c(
              "el-form",
              {
                ref: "search",
                staticClass: "search-form",
                attrs: {
                  slot: "search",
                  inline: true,
                  model: _vm.condition,
                  rules: _vm.searchRules,
                  "label-width": "80px",
                },
                slot: "search",
              },
              [
                _c(
                  "div",
                  {
                    staticStyle: {
                      display: "flex",
                      "justify-content": "space-between",
                    },
                  },
                  [
                    _c("div"),
                    _c("div", [
                      _c("div", { staticClass: "btn-box" }, [
                        _c(
                          "div",
                          [
                            _c(
                              "el-form-item",
                              [
                                _c(
                                  "el-button",
                                  {
                                    attrs: { type: "primary" },
                                    on: { click: _vm.proposalClick },
                                  },
                                  [_vm._v("填写开题报告")]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]),
                    ]),
                  ]
                ),
              ]
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "graduation-tab" },
          [
            _c(
              "el-table",
              {
                attrs: {
                  data: _vm.list,
                  headerRowClassName: "uni-primary-table-header",
                  stripe: "",
                  border: "",
                },
              },
              [
                _c("el-table-column", {
                  attrs: {
                    prop: "title",
                    align: "center",
                    label: "标题",
                    "min-width": "120",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "teacher_opinion",
                    align: "center",
                    label: "老师意见",
                    "min-width": "120",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "agree_open",
                    align: "center",
                    label: "是否同意开题",
                    "min-width": "120",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function ({ row }) {
                        return [
                          _c("span", [
                            _vm._v(_vm._s(row.agree_open == 1 ? "是" : "否")),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "review_status",
                    align: "center",
                    label: "审核状态",
                    "min-width": "120",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function ({ row }) {
                        return [
                          _c(
                            "el-tag",
                            {
                              attrs: {
                                type: _vm._f("reviewStatusStyleFilter")(
                                  row.review_status
                                ),
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm._f("reviewStatusFilter")(
                                    row.review_status
                                  )
                                )
                              ),
                            ]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "created_at",
                    align: "center",
                    label: "提交时间",
                    "min-width": "120",
                  },
                }),
                _c("el-table-column", {
                  attrs: { align: "center", label: "操作", width: "200" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function ({ row }) {
                        return [
                          _c(
                            "el-button",
                            {
                              staticClass: "link-btn",
                              attrs: { type: "text" },
                              on: {
                                click: function ($event) {
                                  return _vm.seeProposal(row)
                                },
                              },
                            },
                            [_vm._v("查看")]
                          ),
                          row.review_status == 1
                            ? _c(
                                "el-button",
                                {
                                  staticClass: "link-btn",
                                  attrs: { type: "text" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.proposalPDF(row)
                                    },
                                  },
                                },
                                [_vm._v("导出PDF")]
                              )
                            : _vm._e(),
                        ]
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _c(
        "el-dialog",
        {
          staticClass: "assignment proposal",
          attrs: {
            title: "",
            visible: _vm.isShowProposal,
            width: "900px",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.isShowProposal = $event
            },
            close: _vm.proposalClose,
          },
        },
        [
          _c(
            "div",
            { staticClass: "cont" },
            [
              _c(
                "el-form",
                {
                  ref: "proposalRef",
                  attrs: {
                    model: _vm.proposalData,
                    rules: _vm.proposalRules,
                    "label-position": "left",
                  },
                },
                [
                  _c("div", { staticClass: "floor border-b" }, [
                    _c("p", { staticClass: "cont-title" }, [
                      _vm._v("毕业论文（设计）开题报告"),
                    ]),
                  ]),
                  _c("div", { staticClass: "floor border-b info-box" }, [
                    _c("div", { staticClass: "item border-r" }, [
                      _c("span", { staticClass: "name" }, [_vm._v("姓名：")]),
                      _c("span", { staticClass: "value" }, [
                        _vm._v(_vm._s(_vm.studentInfo.student_title)),
                      ]),
                    ]),
                    _c("div", { staticClass: "item border-r" }, [
                      _c("span", { staticClass: "name" }, [_vm._v("学号：")]),
                      _c("span", { staticClass: "value" }, [
                        _vm._v(_vm._s(_vm.studentInfo.student_code)),
                      ]),
                    ]),
                    _c("div", { staticClass: "item" }, [
                      _c("span", { staticClass: "name" }, [
                        _vm._v("指导教师："),
                      ]),
                      _c("span", { staticClass: "value" }, [
                        _vm._v(_vm._s(_vm.studentInfo.teacher_title)),
                      ]),
                    ]),
                  ]),
                  _c("div", { staticClass: "floor border-b info-box" }, [
                    _c("div", { staticClass: "item border-r" }, [
                      _c("span", { staticClass: "name" }, [_vm._v("学院：")]),
                      _c("span", { staticClass: "value" }, [
                        _vm._v(_vm._s(_vm.studentInfo.school_title)),
                      ]),
                    ]),
                    _c("div", { staticClass: "item border-r" }, [
                      _c("span", { staticClass: "name" }, [_vm._v("专业：")]),
                      _c("span", { staticClass: "value" }, [
                        _vm._v(_vm._s(_vm.studentInfo.profession_title)),
                      ]),
                    ]),
                  ]),
                  _c(
                    "div",
                    { staticClass: "floor border-b textarea" },
                    [
                      _c("p", { staticClass: "item-title required" }, [
                        _vm._v("题目："),
                      ]),
                      _c(
                        "el-form-item",
                        { attrs: { label: "", prop: "title" } },
                        [
                          _c("el-input", {
                            attrs: {
                              type: "textarea",
                              placeholder: "请输入题目",
                              rows: 4,
                              maxlength: 500,
                              resize: "none",
                              "show-word-limit": "",
                              readonly: _vm.isShowProposalSubmit,
                            },
                            model: {
                              value: _vm.proposalData.title,
                              callback: function ($$v) {
                                _vm.$set(_vm.proposalData, "title", $$v)
                              },
                              expression: "proposalData.title",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "floor border-b textarea" },
                    [
                      _c("p", { staticClass: "item-title required" }, [
                        _vm._v(" 一、选题背景："),
                      ]),
                      _c(
                        "el-form-item",
                        { attrs: { label: "", prop: "content" } },
                        [
                          _c("el-input", {
                            attrs: {
                              type: "textarea",
                              placeholder:
                                "备注：简介选题的基本概念、理论或应用背景，明确主要工作内容、工作目标、预期成果，简要说明选题对专业知识、能力综合训练的情况。",
                              rows: 4,
                              resize: "none",
                              "show-word-limit": "",
                              readonly: _vm.isShowProposalSubmit,
                            },
                            model: {
                              value: _vm.proposalData.background,
                              callback: function ($$v) {
                                _vm.$set(_vm.proposalData, "background", $$v)
                              },
                              expression: "proposalData.background",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "floor border-b textarea" },
                    [
                      _c("p", { staticClass: "item-title required" }, [
                        _vm._v("二、国内外现状："),
                      ]),
                      _c(
                        "el-form-item",
                        { attrs: { label: "", prop: "now_situation" } },
                        [
                          _c("el-input", {
                            attrs: {
                              type: "textarea",
                              placeholder:
                                "备注：学生针对毕业设计（论文）选题所涉及的研究与应用领域，进行广泛地文献查询，在阅读理解、综合分析的基础上总结凝练，应包含自己的客观归纳评述内容，不能仅仅是文献成果的简单堆砌（文献引用处要在句末用“[ ]”上标注明文献出处），应着重说明选题紧密相关的国内现状、国外现状、主要问题与发展趋势。",
                              rows: 4,
                              resize: "none",
                              "show-word-limit": "",
                              readonly: _vm.isShowProposalSubmit,
                            },
                            model: {
                              value: _vm.proposalData.now_situation,
                              callback: function ($$v) {
                                _vm.$set(_vm.proposalData, "now_situation", $$v)
                              },
                              expression: "proposalData.now_situation",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "floor border-b textarea" },
                    [
                      _c("p", { staticClass: "item-title required" }, [
                        _vm._v("三、主要内容："),
                      ]),
                      _c(
                        "el-form-item",
                        { attrs: { label: "", prop: "main_content" } },
                        [
                          _c("el-input", {
                            attrs: {
                              type: "textarea",
                              placeholder:
                                "备注：简要说明具体的工作内容和拟解决的重点难点问题，由学院根据不同类型的选题，明确具体的内容和要求。",
                              rows: 4,
                              resize: "none",
                              "show-word-limit": "",
                              readonly: _vm.isShowProposalSubmit,
                            },
                            model: {
                              value: _vm.proposalData.main_content,
                              callback: function ($$v) {
                                _vm.$set(_vm.proposalData, "main_content", $$v)
                              },
                              expression: "proposalData.main_content",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "floor border-b textarea" },
                    [
                      _c("p", { staticClass: "item-title required" }, [
                        _vm._v("四、方案与计划："),
                      ]),
                      _c(
                        "el-form-item",
                        { attrs: { label: "", prop: "plan_content" } },
                        [
                          _c("el-input", {
                            attrs: {
                              type: "textarea",
                              placeholder:
                                "备注：1.方案，简要说明研究方法、分析思路、技术路线等，如有重点难点问题，说明拟解决办法。2.进度计划，列出时间安排及相应工作内容。以上2点由学院根据不同类型的选题，明确具体的内容和要求。",
                              rows: 4,
                              resize: "none",
                              "show-word-limit": "",
                              readonly: _vm.isShowProposalSubmit,
                            },
                            model: {
                              value: _vm.proposalData.plan_content,
                              callback: function ($$v) {
                                _vm.$set(_vm.proposalData, "plan_content", $$v)
                              },
                              expression: "proposalData.plan_content",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "floor border-b textarea" },
                    [
                      _c("p", { staticClass: "item-title required" }, [
                        _vm._v(" 五、主要参考文献："),
                      ]),
                      _c(
                        "el-form-item",
                        { attrs: { label: "", prop: "reference" } },
                        [
                          _c("el-input", {
                            attrs: {
                              type: "textarea",
                              placeholder: "备注：列出最主要参考文献。",
                              rows: 4,
                              resize: "none",
                              "show-word-limit": "",
                              readonly: _vm.isShowProposalSubmit,
                            },
                            model: {
                              value: _vm.proposalData.reference,
                              callback: function ($$v) {
                                _vm.$set(_vm.proposalData, "reference", $$v)
                              },
                              expression: "proposalData.reference",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("div", { staticClass: "floor border-b table" }, [
                    _c("div", { staticClass: "table-cont" }, [
                      _c("table", { staticClass: "table-box" }, [
                        _c("tr", [
                          _c(
                            "th",
                            { staticClass: "cell", attrs: { colspan: "5" } },
                            [_vm._v("开题纪要")]
                          ),
                        ]),
                        _c("tr", [
                          _c("td", { staticClass: "cell time required" }, [
                            _vm._v("时间"),
                          ]),
                          _c(
                            "td",
                            { staticClass: "cell time-value" },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { prop: "open_time" } },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      readonly: _vm.isShowProposalSubmit,
                                      placeholder: "",
                                    },
                                    model: {
                                      value: _vm.proposalData.open_time,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.proposalData,
                                          "open_time",
                                          $$v
                                        )
                                      },
                                      expression: "proposalData.open_time",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c("td", { staticClass: "cell required" }, [
                            _vm._v("地点"),
                          ]),
                          _c(
                            "td",
                            { staticClass: "cell", attrs: { colspan: "2" } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { prop: "open_place" } },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      readonly: _vm.isShowProposalSubmit,
                                      placeholder: "",
                                    },
                                    model: {
                                      value: _vm.proposalData.open_place,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.proposalData,
                                          "open_place",
                                          $$v
                                        )
                                      },
                                      expression: "proposalData.open_place",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]),
                        _c("tr", [
                          _c("td", { staticClass: "cell required" }, [
                            _vm._v("参与人员"),
                          ]),
                          _c(
                            "td",
                            { staticClass: "cell", attrs: { colspan: "4" } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { prop: "open_participant" } },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      readonly: _vm.isShowProposalSubmit,
                                      placeholder: "",
                                    },
                                    model: {
                                      value: _vm.proposalData.open_participant,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.proposalData,
                                          "open_participant",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "proposalData.open_participant",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]),
                        _c("tr", { staticClass: "cell" }, [
                          _c("td", { staticClass: "cell required" }, [
                            _c("p", [_vm._v("开")]),
                            _c("p", [_vm._v("题")]),
                            _c("p", [_vm._v("工")]),
                            _c("p", [_vm._v("作")]),
                            _c("p", [_vm._v("记")]),
                            _c("p", [_vm._v("录")]),
                          ]),
                          _c(
                            "td",
                            { staticClass: "cell", attrs: { colspan: "4" } },
                            [
                              _c(
                                "div",
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { prop: "work_record" } },
                                    [
                                      _c("el-input", {
                                        attrs: {
                                          type: "textarea",
                                          placeholder:
                                            "备注：详细说明开题情况。",
                                          rows: 4,
                                          resize: "none",
                                          "show-word-limit": "",
                                          readonly: _vm.isShowProposalSubmit,
                                        },
                                        model: {
                                          value: _vm.proposalData.work_record,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.proposalData,
                                              "work_record",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "proposalData.work_record",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "div",
                                { staticClass: "floor-bot" },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: "学生签名：",
                                        prop: "student_sign_img",
                                      },
                                    },
                                    [
                                      _vm.isShowProposalSubmit
                                        ? _c("el-image", {
                                            staticClass: "see-img",
                                            attrs: {
                                              src: _vm.proposalData
                                                .student_sign_img,
                                            },
                                          })
                                        : _c("esignHandle", {
                                            ref: "esignHandle4",
                                            attrs: {
                                              selectSignImg:
                                                _vm.proposalData
                                                  .student_sign_img,
                                            },
                                            on: {
                                              "update:selectSignImg": function (
                                                $event
                                              ) {
                                                return _vm.$set(
                                                  _vm.proposalData,
                                                  "student_sign_img",
                                                  $event
                                                )
                                              },
                                              "update:select-sign-img":
                                                function ($event) {
                                                  return _vm.$set(
                                                    _vm.proposalData,
                                                    "student_sign_img",
                                                    $event
                                                  )
                                                },
                                              selectSignImgAfter: function (
                                                $event
                                              ) {
                                                return _vm.studentSignImgAfter(
                                                  $event,
                                                  "proposalRef",
                                                  "student_sign_img"
                                                )
                                              },
                                            },
                                          }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: "",
                                        prop: "student_sign_date",
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "date-box required" },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "text value" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.proposalData
                                                    .studentSignDate.year
                                                )
                                              ),
                                            ]
                                          ),
                                          _c("span", { staticClass: "text" }, [
                                            _vm._v("年"),
                                          ]),
                                          _c(
                                            "span",
                                            { staticClass: "text value" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.proposalData
                                                    .studentSignDate.month
                                                )
                                              ),
                                            ]
                                          ),
                                          _c("span", { staticClass: "text" }, [
                                            _vm._v("月"),
                                          ]),
                                          _c(
                                            "span",
                                            { staticClass: "text value" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.proposalData
                                                    .studentSignDate.day
                                                )
                                              ),
                                            ]
                                          ),
                                          _c("span", { staticClass: "text" }, [
                                            _vm._v("日"),
                                          ]),
                                        ]
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ]
                          ),
                        ]),
                        _c("tr", { staticClass: "cell" }, [
                          _c("td", { staticClass: "cell" }, [
                            _c("p", [_vm._v("指")]),
                            _c("p", [_vm._v("导")]),
                            _c("p", [_vm._v("教")]),
                            _c("p", [_vm._v("师")]),
                            _c("p", [_vm._v("意")]),
                            _c("p", [_vm._v("见")]),
                          ]),
                          _c(
                            "td",
                            { staticClass: "cell", attrs: { colspan: "4" } },
                            [
                              _c(
                                "div",
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { prop: "teacher_opinion" } },
                                    [
                                      _c("el-input", {
                                        attrs: {
                                          type: "textarea",
                                          placeholder:
                                            "备注：对学生的开题报告做全面做评价，明确是否同意开题。",
                                          rows: 4,
                                          maxlength: 500,
                                          resize: "none",
                                          "show-word-limit": "",
                                          readonly: "",
                                        },
                                        model: {
                                          value:
                                            _vm.proposalData.teacher_opinion,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.proposalData,
                                              "teacher_opinion",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "proposalData.teacher_opinion",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "div",
                                { staticClass: "radio-box" },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { prop: "agree_open" } },
                                    [
                                      _c(
                                        "el-radio-group",
                                        {
                                          attrs: { disabled: true },
                                          model: {
                                            value: _vm.proposalData.agree_open,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.proposalData,
                                                "agree_open",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "proposalData.agree_open",
                                          },
                                        },
                                        [
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 1 } },
                                            [_vm._v("同意开题")]
                                          ),
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 0 } },
                                            [_vm._v("不同意开题")]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "div",
                                { staticClass: "floor-bot" },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: "教师签名：",
                                        prop: "teacher_sign_img",
                                      },
                                    },
                                    [
                                      _vm.isShowProposalSubmit &&
                                      !!_vm.proposalData.teacher_sign_img
                                        ? _c("el-image", {
                                            staticClass: "see-img",
                                            attrs: {
                                              src: _vm.proposalData
                                                .teacher_sign_img,
                                            },
                                          })
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: "",
                                        prop: "teacher_sign_date",
                                      },
                                    },
                                    [
                                      _c("div", { staticClass: "date-box" }, [
                                        _c(
                                          "span",
                                          { staticClass: "text value" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.proposalData.teacherSignDate
                                                  .year
                                              )
                                            ),
                                          ]
                                        ),
                                        _c("span", { staticClass: "text" }, [
                                          _vm._v("年"),
                                        ]),
                                        _c(
                                          "span",
                                          { staticClass: "text value" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.proposalData.teacherSignDate
                                                  .month
                                              )
                                            ),
                                          ]
                                        ),
                                        _c("span", { staticClass: "text" }, [
                                          _vm._v("月"),
                                        ]),
                                        _c(
                                          "span",
                                          { staticClass: "text value" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.proposalData.teacherSignDate
                                                  .day
                                              )
                                            ),
                                          ]
                                        ),
                                        _c("span", { staticClass: "text" }, [
                                          _vm._v("日"),
                                        ]),
                                      ]),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ]
                          ),
                        ]),
                      ]),
                    ]),
                  ]),
                ]
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticStyle: { "text-align": "center", "margin-top": "20px" } },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.isShowProposal = false
                    },
                  },
                },
                [_vm._v("关闭")]
              ),
              !_vm.isShowProposalSubmit
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.proposalSubmit },
                    },
                    [_vm._v("确认提交")]
                  )
                : _vm._e(),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          staticClass: "assignment proposal",
          attrs: {
            title: "",
            visible: _vm.isShowProposalPDF,
            width: "900px",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.isShowProposalPDF = $event
            },
            close: _vm.proposalClose,
          },
        },
        [
          _c("div", { ref: "proposalRefPDF", staticClass: "proposalPDF-box" }, [
            _c("div", { staticClass: "assignment-pdf-cover" }, [
              _c("div", { staticClass: "title-box" }, [
                _c("p", { staticClass: "title1" }, [_vm._v("重庆医科大学")]),
                _c("p", { staticClass: "title2" }, [_vm._v("成人高等教育")]),
                _c("p", { staticClass: "title2" }, [
                  _vm._v("毕业论文（设计）开题报告"),
                ]),
              ]),
              _c("div", { staticClass: "cover-box" }, [
                _c("div", { staticClass: "item" }, [
                  _c("p", { staticClass: "name" }, [
                    _c("span", { staticClass: "text" }, [_vm._v("题")]),
                    _c("span", { staticClass: "text" }, [_vm._v("目：")]),
                  ]),
                  _c("p", { staticClass: "value" }, [
                    _vm._v(_vm._s(_vm.proposalData.title)),
                  ]),
                ]),
                _c("div", { staticClass: "item" }, [
                  _c("p", { staticClass: "name" }, [
                    _c("span", { staticClass: "text" }, [_vm._v("学")]),
                    _c("span", { staticClass: "text" }, [_vm._v("院：")]),
                  ]),
                  _c("p", { staticClass: "value" }, [_vm._v("继续教育学院")]),
                ]),
                _c("div", { staticClass: "item" }, [
                  _c("p", { staticClass: "name" }, [
                    _c("span", { staticClass: "text" }, [_vm._v("专")]),
                    _c("span", { staticClass: "text" }, [_vm._v("业：")]),
                  ]),
                  _c("p", { staticClass: "value" }, [
                    _vm._v(_vm._s(_vm.studentInfo.profession_title)),
                  ]),
                ]),
                _c("div", { staticClass: "item" }, [
                  _c("p", { staticClass: "name" }, [
                    _c("span", { staticClass: "text" }, [_vm._v("学")]),
                    _c("span", { staticClass: "text" }, [_vm._v("生")]),
                    _c("span", { staticClass: "text" }, [_vm._v("姓")]),
                    _c("span", { staticClass: "text" }, [_vm._v("名：")]),
                  ]),
                  _c("p", { staticClass: "value" }, [
                    _vm._v(_vm._s(_vm.studentInfo.student_title)),
                  ]),
                ]),
                _c("div", { staticClass: "item" }, [
                  _c("p", { staticClass: "name" }, [
                    _c("span", { staticClass: "text" }, [_vm._v("学")]),
                    _c("span", { staticClass: "text" }, [_vm._v("号：")]),
                  ]),
                  _c("p", { staticClass: "value" }, [
                    _vm._v(_vm._s(_vm.studentInfo.student_code)),
                  ]),
                ]),
                _c("div", { staticClass: "item" }, [
                  _c("p", { staticClass: "name" }, [
                    _c("span", { staticClass: "text" }, [_vm._v("指")]),
                    _c("span", { staticClass: "text" }, [_vm._v("导")]),
                    _c("span", { staticClass: "text" }, [_vm._v("老")]),
                    _c("span", { staticClass: "text" }, [_vm._v("师：")]),
                  ]),
                  _c("p", { staticClass: "value" }, [
                    _vm._v(_vm._s(_vm.studentInfo.teacher_title)),
                  ]),
                ]),
              ]),
            ]),
            _c(
              "div",
              { staticClass: "proposalPDF" },
              [
                _c(
                  "el-form",
                  {
                    ref: "proposalRef",
                    attrs: {
                      model: _vm.proposalData,
                      rules: _vm.proposalRules,
                      "label-position": "left",
                    },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "floor border-b textarea" },
                      [
                        _c("p", { staticClass: "item-title" }, [
                          _vm._v(" 一、选题背景："),
                        ]),
                        _c(
                          "el-form-item",
                          { attrs: { label: "", prop: "content" } },
                          [
                            _c(
                              "p",
                              {
                                staticStyle: {
                                  padding: "5px 15px",
                                  "white-space": "pre-wrap",
                                },
                              },
                              [_vm._v(_vm._s(_vm.proposalData.background))]
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "floor border-b textarea" },
                      [
                        _c("p", { staticClass: "item-title" }, [
                          _vm._v("二、国内外现状："),
                        ]),
                        _c(
                          "el-form-item",
                          { attrs: { label: "", prop: "now_situation" } },
                          [
                            _c(
                              "p",
                              {
                                staticStyle: {
                                  padding: "5px 15px",
                                  "white-space": "pre-wrap",
                                },
                              },
                              [_vm._v(_vm._s(_vm.proposalData.now_situation))]
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "floor border-b textarea" },
                      [
                        _c("p", { staticClass: "item-title" }, [
                          _vm._v("三、主要内容："),
                        ]),
                        _c(
                          "el-form-item",
                          { attrs: { label: "", prop: "main_content" } },
                          [
                            _c(
                              "p",
                              {
                                staticStyle: {
                                  padding: "5px 15px",
                                  "white-space": "pre-wrap",
                                },
                              },
                              [_vm._v(_vm._s(_vm.proposalData.main_content))]
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "floor border-b textarea" },
                      [
                        _c("p", { staticClass: "item-title" }, [
                          _vm._v("四、方案与计划："),
                        ]),
                        _c(
                          "el-form-item",
                          { attrs: { label: "", prop: "plan_content" } },
                          [
                            _c(
                              "p",
                              {
                                staticStyle: {
                                  padding: "5px 15px",
                                  "white-space": "pre-wrap",
                                },
                              },
                              [_vm._v(_vm._s(_vm.proposalData.plan_content))]
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "floor border-b textarea" },
                      [
                        _c("p", { staticClass: "item-title" }, [
                          _vm._v(" 五、主要参考文献："),
                        ]),
                        _c(
                          "el-form-item",
                          { attrs: { label: "", prop: "reference" } },
                          [
                            _c(
                              "p",
                              {
                                staticStyle: {
                                  padding: "5px 15px",
                                  "white-space": "pre-wrap",
                                },
                              },
                              [_vm._v(_vm._s(_vm.proposalData.reference))]
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                    _c("div", { staticClass: "floor border-b table" }, [
                      _c("div", { staticClass: "table-cont" }, [
                        _c("table", { staticClass: "table-box" }, [
                          _c("tr", [
                            _c(
                              "th",
                              { staticClass: "cell", attrs: { colspan: "5" } },
                              [_vm._v("开题纪要")]
                            ),
                          ]),
                          _c("tr", [
                            _c("td", { staticClass: "cell time" }, [
                              _vm._v("时间"),
                            ]),
                            _c("td", { staticClass: "cell time-value" }, [
                              _vm._v(
                                " " + _vm._s(_vm.proposalData.open_time) + " "
                              ),
                            ]),
                            _c("td", { staticClass: "cell" }, [_vm._v("地点")]),
                            _c(
                              "td",
                              { staticClass: "cell", attrs: { colspan: "2" } },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.proposalData.open_place) +
                                    " "
                                ),
                              ]
                            ),
                          ]),
                          _c("tr", [
                            _c("td", { staticClass: "cell" }, [
                              _vm._v("参与人员"),
                            ]),
                            _c(
                              "td",
                              {
                                staticClass: "cell left",
                                attrs: { colspan: "4" },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.proposalData.open_participant) +
                                    " "
                                ),
                              ]
                            ),
                          ]),
                          _c("tr", { staticClass: "cell" }, [
                            _c("td", { staticClass: "cell" }, [
                              _c("p", [_vm._v("开")]),
                              _c("p", [_vm._v("题")]),
                              _c("p", [_vm._v("工")]),
                              _c("p", [_vm._v("作")]),
                              _c("p", [_vm._v("记")]),
                              _c("p", [_vm._v("录")]),
                            ]),
                            _c(
                              "td",
                              {
                                staticClass: "cell left",
                                attrs: { colspan: "4" },
                              },
                              [
                                _c("div", [
                                  _c(
                                    "p",
                                    {
                                      staticStyle: {
                                        padding: "5px 15px",
                                        "white-space": "pre-wrap",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.proposalData.work_record)
                                      ),
                                    ]
                                  ),
                                ]),
                                _c(
                                  "div",
                                  { staticClass: "floor-bot" },
                                  [
                                    _c(
                                      "el-form-item",
                                      { attrs: { label: "学生签名：" } },
                                      [
                                        _c("el-image", {
                                          staticStyle: {
                                            width: "50px",
                                            height: "50px",
                                          },
                                          attrs: {
                                            src: _vm.proposalData
                                              .student_sign_img,
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: "",
                                          prop: "student_sign_date",
                                        },
                                      },
                                      [
                                        _c("div", { staticClass: "date-box" }, [
                                          _c(
                                            "span",
                                            { staticClass: "text value" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.proposalData
                                                    .studentSignDate.year
                                                )
                                              ),
                                            ]
                                          ),
                                          _c("span", { staticClass: "text" }, [
                                            _vm._v("年"),
                                          ]),
                                          _c(
                                            "span",
                                            { staticClass: "text value" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.proposalData
                                                    .studentSignDate.month
                                                )
                                              ),
                                            ]
                                          ),
                                          _c("span", { staticClass: "text" }, [
                                            _vm._v("月"),
                                          ]),
                                          _c(
                                            "span",
                                            { staticClass: "text value" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.proposalData
                                                    .studentSignDate.day
                                                )
                                              ),
                                            ]
                                          ),
                                          _c("span", { staticClass: "text" }, [
                                            _vm._v("日"),
                                          ]),
                                        ]),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            ),
                          ]),
                          _c("tr", { staticClass: "cell" }, [
                            _c("td", { staticClass: "cell" }, [
                              _c("p", [_vm._v("指")]),
                              _c("p", [_vm._v("导")]),
                              _c("p", [_vm._v("教")]),
                              _c("p", [_vm._v("师")]),
                              _c("p", [_vm._v("意")]),
                              _c("p", [_vm._v("见")]),
                            ]),
                            _c(
                              "td",
                              {
                                staticClass: "cell left",
                                attrs: { colspan: "4" },
                              },
                              [
                                _c("div", [
                                  _c(
                                    "p",
                                    {
                                      staticStyle: {
                                        padding: "5px 15px",
                                        "white-space": "pre-wrap",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.proposalData.teacher_opinion)
                                      ),
                                    ]
                                  ),
                                ]),
                                _c(
                                  "div",
                                  { staticClass: "radio-box" },
                                  [
                                    _c(
                                      "el-form-item",
                                      { attrs: { prop: "agree_open" } },
                                      [
                                        _c(
                                          "el-radio-group",
                                          {
                                            attrs: { disabled: true },
                                            model: {
                                              value:
                                                _vm.proposalData.agree_open,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.proposalData,
                                                  "agree_open",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "proposalData.agree_open",
                                            },
                                          },
                                          [
                                            _c(
                                              "el-radio",
                                              { attrs: { label: 1 } },
                                              [_vm._v("同意开题")]
                                            ),
                                            _c(
                                              "el-radio",
                                              { attrs: { label: 0 } },
                                              [_vm._v("不同意开题")]
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  { staticClass: "floor-bot" },
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: "教师签名：",
                                          prop: "teacher_sign_img",
                                        },
                                      },
                                      [
                                        _c("el-image", {
                                          staticStyle: {
                                            width: "50px",
                                            height: "50px",
                                          },
                                          attrs: {
                                            src: _vm.proposalData
                                              .teacher_sign_img,
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: "",
                                          prop: "teacher_sign_date",
                                        },
                                      },
                                      [
                                        _c("div", { staticClass: "date-box" }, [
                                          _c(
                                            "span",
                                            { staticClass: "text value" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.proposalData
                                                    .teacherSignDate.year
                                                )
                                              ),
                                            ]
                                          ),
                                          _c("span", { staticClass: "text" }, [
                                            _vm._v("年"),
                                          ]),
                                          _c(
                                            "span",
                                            { staticClass: "text value" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.proposalData
                                                    .teacherSignDate.month
                                                )
                                              ),
                                            ]
                                          ),
                                          _c("span", { staticClass: "text" }, [
                                            _vm._v("月"),
                                          ]),
                                          _c(
                                            "span",
                                            { staticClass: "text value" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.proposalData
                                                    .teacherSignDate.day
                                                )
                                              ),
                                            ]
                                          ),
                                          _c("span", { staticClass: "text" }, [
                                            _vm._v("日"),
                                          ]),
                                        ]),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            ),
                          ]),
                        ]),
                      ]),
                    ]),
                  ]
                ),
              ],
              1
            ),
          ]),
          _c(
            "div",
            { staticStyle: { "text-align": "center", "margin-top": "20px" } },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.isShowProposalPDF = false
                    },
                  },
                },
                [_vm._v("关闭")]
              ),
              _c("el-button", { on: { click: _vm.proposalExportPDF } }, [
                _vm._v("导出PDF"),
              ]),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }